import { Box, Divider } from "@wix/design-system";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context";
import { AFTER_PARAGRAPH_INPUT, BEFORE_PARAGRAPH_INPUT, LINE_SPACING_INPUT } from "../data-hooks";
import { InputWithLabel } from "./input-with-label/input-with-label";
const CustomSpacingEditor = ({
  lineSpacing,
  setLineSpacing
}) => {
  const { t, isMobile } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(Box, { direction: "vertical", width: isMobile ? "100%" : "250px" }, /* @__PURE__ */ React.createElement(Box, { direction: "vertical", padding: "18px 24px", gap: "15px" }, /* @__PURE__ */ React.createElement(
    InputWithLabel,
    {
      label: t("LineSpacing_lineSpacing"),
      value: lineSpacing["line-height"],
      onChange: (value) => {
        setLineSpacing({ ...lineSpacing, "line-height": value });
      },
      min: 0,
      max: 100,
      dataHook: LINE_SPACING_INPUT
    }
  ), /* @__PURE__ */ React.createElement(Divider, null), /* @__PURE__ */ React.createElement(
    InputWithLabel,
    {
      label: t("LineSpacing_beforeParagraph"),
      value: lineSpacing["padding-top"],
      onChange: (value) => {
        setLineSpacing({ ...lineSpacing, "padding-top": value });
      },
      min: 0,
      max: 250,
      dataHook: BEFORE_PARAGRAPH_INPUT
    }
  ), /* @__PURE__ */ React.createElement(
    InputWithLabel,
    {
      label: t("LineSpacing_afterParagraph"),
      value: lineSpacing["padding-bottom"],
      onChange: (value) => {
        setLineSpacing({ ...lineSpacing, "padding-bottom": value });
      },
      min: 0,
      max: 250,
      dataHook: AFTER_PARAGRAPH_INPUT
    }
  )));
};
export {
  CustomSpacingEditor
};
//# sourceMappingURL=custom-spacing-editor.js.map
